import React, {useEffect, useReducer, useState} from 'react';
import SimpleDialog from "../../dialogs/SimpleDialog";
import { Skeleton } from '@mui/material';
import Grid from "@mui/material/Grid";
import {
	Button, Card, CardHeader,
	DialogActions, DialogContentText, Typography,
} from "@mui/material";
import {initIntervistaState, INTERVISTA_INITIAL_STATE, IntervistaReducer} from "../../../../reducers/IntervistaReducer";
import {getIntervistaById} from "../../../../services/IntervistaServices";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {useHistory} from "react-router-dom";
import {useForm, FormProvider} from "react-hook-form";
import {SintomiGrid} from "../../../gestione/interviste/intervista/content/SintomiGrid";
import {resetIntervista} from "../../../gestione/interviste/intervista/utils/ResetUtils";
import {InfoLavorativeGrid} from "../../../gestione/interviste/intervista/content/InfoLavorativeGrid";
import {RischioGrid} from "../../../gestione/interviste/intervista/content/RischioGrid";
import moment from "moment";
import {amber} from "@mui/material/colors";

const IntervistaDialog = ({idIntervista, setIntervista}) => {
	const classes = BaseStyle();
	const [intervistaState, intervistaDispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const [intervista, setSelected] = useState({});
	const [reset, setReset] = useState(false)
	const methods = useForm({
		mode: "onChange",
	});
	const [value1, setValue1] = useState("");
	const [inputValue1, setInputValue1] = useState("");
	let history = useHistory();
	
	useEffect(() => {
		getIntervistaById(idIntervista, intervistaDispatch)
	}, [idIntervista, intervistaDispatch])
	
	useEffect(() => {
		if (!intervistaState.loadingGetIntervista && intervistaState.errorGetIntervista === "") {
			setSelected(intervistaState.intervista);
			if (!reset) {
				methods.reset(resetIntervista(intervistaState.intervista));
				setReset(true);
			}
		}
	}, [intervistaState.loadingGetIntervista, intervistaState.errorGetIntervista, intervistaState.intervista, reset, methods])
	
	return (
        <React.Fragment>
            <SimpleDialog
				maxWidth={"md"}
				open={idIntervista !== ""}
				title={"Intervista " + idIntervista}
				handleClose={() => setIntervista("")}
				content={<React.Fragment>
					{
						intervistaState.loadingGetIntervista ? <Skeleton height={500} style={{borderRadius: 24}}/> :
							intervistaState.errorGetIntervista !== "" ? "Err..." :
								<React.Fragment>
									<DialogContentText>
										Qui visualizzi l'intervista allo stesso modo del cittadino. Se ritieni necessario aggiornare o
										modificare i campi utilizza il bottone "AGGIORNA" che trovi in basso a destra del dialog.
									</DialogContentText>
									<FormProvider {...methods}>
										<Grid container spacing={3}>
											<InfoLavorativeGrid value={value1} setInputValue={setInputValue1} setValue={setValue1}
											                    inputValue={inputValue1}/>
											<SintomiGrid dataSintomiReq={false}/>
											<RischioGrid/>
											
											<Grid item xs={12}>
												<Typography>
													<b>{
														intervista.note && intervista.note.includes("[{\"tipoDocumento\":") ?
															"Contatti dichiarati" : "Note:"
													}</b>
												</Typography>
												<Typography color={"textSecondary"} component={"div"}
												            style={{paddingBottom: 20, paddingTop: 20}}>
													{
														intervista.note && intervista.note.includes("[{\"tipoDocumento\":") ?
															JSON.parse(
																intervista.note
																	.replaceAll("#COMPILATA_CITTADINO ", "")
																	.replaceAll("null", "")
																	.replaceAll(/#(\S*)/g, "")
															)?.map((contatto, index) => {
																return (
																	<Card key={index}
																	      style={{marginTop: 4, borderRadius: 24, backgroundColor: amber[50]}}>
																		<CardHeader title={
																			<Typography variant={"subtitle1"}>
																				<b>{contatto?.nome + " " + contatto?.cognome}</b><br/>
																				email: {contatto?.email}<br/>
																				cell : {contatto?.cell}<br/>
																				codice fiscale: {contatto?.codiceFiscale ? contatto?.codiceFiscale : "--"}<br/>
																				sintomi: {
																				contatto.sintomi?.map((sintomo, index) => <span key={index}
																				                                                style={{
																					                                                color: "#FFF",
																					                                                backgroundColor: amber[900],
																					                                                padding: 2,
																					                                                paddingRight: 6,
																					                                                paddingLeft: 6,
																					                                                borderRadius: 22,
																					                                                marginRight: 4
																				                                                }}>{sintomo}</span>)
																			}<br/>
																				comparsa sintomi: {moment(contatto?.dataComparsaSintomi).format("DD/MM/YYYY")}
																			</Typography>
																		}/>
																	</Card>)
															}) :
															intervista.note
													}
												</Typography>
											</Grid>
										</Grid>
									</FormProvider>
								</React.Fragment>
					}
				</React.Fragment>}
				actions={
					<DialogActions className={classes.flexRight}>
						<Button variant={"text"} disableElevation size={"small"}
						        disabled={true}
							/*disabled={intervistaState.intervista.focolaioId === null}*/
							      onClick={() => history.push("/gestione/interviste/" + idIntervista)}
							      className={classes.roundButton} style={{borderRadius: 24}}>
							<b>Aggiorna</b>
						</Button>
						<Button variant={"contained"} disableElevation size={"small"} color={"primary"}
						        onClick={() => setIntervista("")} className={classes.roundButton} style={{borderRadius: 24}}>
							<b>Chiudi</b>
						</Button>
					</DialogActions>
				}
			/>
        </React.Fragment>
    );
};

export default React.memo(IntervistaDialog)
